function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export function contentSidePadding(breakpoints, spacing) {
  var _ref;
  return _ref = {}, _defineProperty(_ref, breakpoints.down('md'), {
    paddingLeft: spacing(2),
    paddingRight: spacing(2)
  }), _defineProperty(_ref, breakpoints.up('md'), {
    paddingLeft: spacing(3),
    paddingRight: spacing(3)
  }), _defineProperty(_ref, breakpoints.up('lg'), {
    paddingLeft: spacing(3),
    paddingRight: spacing(3)
  }), _defineProperty(_ref, breakpoints.up('xl'), {
    paddingLeft: spacing(6),
    paddingRight: spacing(6)
  }), _ref;
}
export function contentTopPadding(spacing) {
  return {
    paddingTop: spacing(3)
  };
}
export function headerPadding(breakpoints, spacing) {
  var _ref2;
  return _ref2 = {}, _defineProperty(_ref2, breakpoints.down('md'), {
    paddingInline: spacing(3)
  }), _defineProperty(_ref2, breakpoints.up('md'), {
    paddingInline: spacing(4)
  }), _defineProperty(_ref2, breakpoints.up('xl'), {
    paddingInline: spacing(6)
  }), _ref2;
}
export function tabBarPadding(breakpoints, spacing) {
  var _ref3;
  return _ref3 = {}, _defineProperty(_ref3, breakpoints.down('md'), {
    paddingInline: spacing(1)
  }), _defineProperty(_ref3, breakpoints.up('md'), {
    paddingInline: spacing(2)
  }), _defineProperty(_ref3, breakpoints.up('xl'), {
    paddingInline: spacing(3)
  }), _ref3;
}
export function contentToolbarActions(breakpoints, spacing) {
  var _ref4;
  return _ref4 = {}, _defineProperty(_ref4, breakpoints.down('md'), {
    paddingInline: spacing(2)
  }), _defineProperty(_ref4, breakpoints.up('md'), {
    paddingInline: spacing(3)
  }), _defineProperty(_ref4, breakpoints.up('xl'), {
    paddingInline: spacing(5)
  }), _ref4;
}
export function contentTablePadding(breakpoints, spacing) {
  var _ref5;
  return _ref5 = {}, _defineProperty(_ref5, breakpoints.down('md'), {
    paddingInline: spacing(1)
  }), _defineProperty(_ref5, breakpoints.up('md'), {
    paddingInline: spacing(1),
    marginInline: spacing(2)
  }), _defineProperty(_ref5, breakpoints.up('xl'), {
    paddingInline: spacing(1),
    marginInline: spacing(3)
  }), _ref5;
}